import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

const t = {
  arrived: 'Arrived at',
  unloaded: 'Unloaded at',
  loaded: 'Loaded at',
  started: 'Started at',
  not_started: 'Not started',
  late: 'late',
  waiting: 'Waiting',
  time: 'HH:mm',
  min: 'min',
  days: 'days',
  h: 'h',
  possible_delay: 'Possible Delay',
};

const lateText = ({ mins_late, hours_late, days_late }) => {
  if (mins_late < 0) {
    return '';
  }

  if (mins_late < 60) {
    return `${mins_late} ${t.min}`;
  }

  if (hours_late < 24) {
    const minutes_late_to_show = ('0' + (mins_late % 60)).slice(-2);
    return `${hours_late}${t.h} ${minutes_late_to_show}${t.min}`;
  }

  return `${days_late} ${t.days}`;
};

const formatMap = {
  STOP_NOT_STARTED: () => t.not_started,
  STOP_STANDSTILL: () => t.waiting,
  STOP_LATE: ({ stopTimeTo }) => {
    const mins_late = moment().diff(stopTimeTo, 'minutes');
    const hours_late = moment().diff(stopTimeTo, 'hours');
    const days_late = moment().diff(stopTimeTo, 'days');

    return `${lateText({ mins_late, hours_late, days_late })} ${t.late}`;
  },
  STOP_POSSIBLE_DELAY: ({ delayedDateTime }) => {
    const time = moment(delayedDateTime);
    return `${t.possible_delay} ${time.format('HH:mm')}`;
  },
};

const formatWarning = (warning, params) => {
  return formatMap[warning] ? formatMap[warning](params) : warning;
};

const StageWarning = React.memo(
  ({ warning, possibleWarning, stopTimeTo, delayedDateTime, className }) => {
    if (!warning && !possibleWarning) {
      return null;
    }

    return (
      <div className={className}>
        {!!warning && formatWarning(warning, { stopTimeTo, t })}
        {!!possibleWarning &&
          !warning &&
          formatWarning(possibleWarning, { delayedDateTime, stopTimeTo, t })}
      </div>
    );
  }
);

StageWarning.propTypes = {
  warning: PropTypes.string,
  possibleWarning: PropTypes.string,
  stopTimeTo: PropTypes.string,
  delayedDateTime: PropTypes.string,
  className: PropTypes.string,
};

export default StageWarning;
